import React from "react"
import { Flex, Text, Box, Heading, Link, Grid } from "@chakra-ui/react"
import { css } from "@emotion/react"
import { LinkedinIcon } from "react-share"
import { colors } from "../colors/colors"
import { CloseButton } from "../button/CloseButton"
import { Image } from "../image/Image"

export function TileModal({ item, onReset }) {
  const image =
    item?.teamFields?.youthPhoto?.localFile?.childImageSharp ||
    item?.featuredImage?.node?.localFile?.childImageSharp

  return (
    <Box
      key={item.id}
      bg={colors.bggray}
      p={`40px 22px`}
      position="relative"
      height="100%"
      overflow="auto"
    >
      <Grid gridGap={50} gridTemplateColumns="1fr auto">
        {image && <Image className={css({ width: `100%` })} image={image} />}

        <Box position="fixed" right="4px" top="72px">
          <CloseButton
            color={colors.gray}
            hoverColor={colors.purple}
            onClick={onReset}
            height="24px"
          />
        </Box>
      </Grid>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={"20px"}>
        <Box>
          <Heading
            as="h3"
            fontSize={20}
            lineHeight="29px"
            m={`22px 0 0`}
            textTransform="uppercase"
            textAlign="left"
            fontWeight={600}
            color="black"
          >
            {item.title}
          </Heading>
          <Heading
            as="p"
            color={colors.blue}
            fontSize={16}
            textTransform="uppercase"
            m={0}
            lineHeight="20px"
            fontWeight={600}
          >
            {item.teamFields?.role}
          </Heading>
        </Box>
        {item?.teamFields?.linkedin && (
          <Link href={item?.teamFields?.linkedin} target="_blank">
            <LinkedinIcon
              bgStyle={{ fill: colors.blue }}
              style={{ width: 32, height: 32 }}
            />
          </Link>
        )}
      </Flex>
      <Text
        m={{ sm: `0` }}
        color="black"
        dangerouslySetInnerHTML={{ __html: item.content }}
      />
    </Box>
  )
}
